import {adminGet, dictMap, countryMap, getOptions, getPermission, login, logout} from '@/api/sys'
import {getToken, removeToken, setToken} from '@/utils/auth'
import {resetRouter} from '@/router'

const state = {
  token: getToken(),
  name: 'sys',
  avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
  introduction: '',
  roles: [],
  permissions: {},
  layout: {},
  dictMap: {},
  countryMap: {},
  options: [],
  admin: {},
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  SET_LAYOUT: (state, layout) => {
    state.layout = layout
  },
  SET_DICT_MAP: (state, dictMap) => {
    state.dictMap = dictMap
  },
  SET_COUNTRY_MAP: (state, countryMap) => {
    state.countryMap = countryMap
  },
  SET_OPTIONS: (state, options) => {
    state.options = options
  },
  SET_ADMIN: (state, admin) => {
    state.admin = admin
  }
}

const actions = {
  // user login
  login({commit}, admin) {
    const {username, password, code} = admin
    return new Promise((resolve, reject) => {
      login({username: username.trim(), password: password, code: code, type: 'admin'})
        .then(response => {
          const {data} = response
          commit('SET_TOKEN', data.token)
          setToken(data.token)
          commit('SET_ADMIN', data)
          resolve()
        }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  logout({commit, state, dispatch}) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        resetRouter()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, {root: true})

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDictMap({commit, state}) {
    return new Promise((resolve, reject) => {
      dictMap().then(res => {
        const {data} = res
        commit('SET_DICT_MAP', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCountryMap({commit, state}) {
    return new Promise((resolve, reject) => {
      countryMap().then(res => {
        const {data} = res
        commit('SET_COUNTRY_MAP', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOptions({commit, state}) {
    return new Promise((resolve, reject) => {
      getOptions().then(res => {
        const {data} = res
        commit('SET_OPTIONS', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // get permissions info
  getPermission({commit, state}) {
    return new Promise((resolve, reject) => {
      getPermission().then(res => {
        const {data, layout} = res
        commit('SET_PERMISSIONS', data)
        commit('SET_LAYOUT', layout)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAdmin({commit, state}) {
    return new Promise((resolve, reject) => {
      adminGet().then(res => {
        const {data} = res
        commit('SET_ADMIN', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  setRoles({commit}, roles) {
    commit("SET_ROLES", roles)
  },
  // remove token
  resetToken({commit}) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/admin/store/modules/sys.js